module.exports = __webpack_public_path__ + "static/media/car-registration-blue.9dda6cb6.svg";